<template>
  <img src="@/assets/images/Clap.svg" alt="Thank you for your participation" :width="`${width}px`">
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '60',
    },
  },
}
</script>

<style lang="scss">
img {
  height: auto;
}
</style>
